import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
  Table,
  Select,
  DatePicker,
  Button,
  Form,
  Input,
  Tooltip,
  Tag,
  Divider,
} from "antd";
import {
  DownloadOutlined,
  UploadOutlined,
  ExportOutlined,
} from "@ant-design/icons";
import { getStates } from "../features/statecity/statecitySlice";
import { getMous } from "../features/mou/mouSlice";
import { getJobtrades, getSectors } from "../features/brand/brandSlice";
import { formatDate, getDateDifference } from "../utils/dateHelper";
import axios from "axios";
// import { config } from "../utils/axiosconfig";
import { base_url } from "../utils/baseUrl";
import { CSVLink } from "react-csv";
// import locale from "antd/locale/en_US";
import dayjs from "dayjs";
import "dayjs/locale/en-in";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale("en-in");
dayjs.tz.setDefault("Asia/Kolkata");

const { Option } = Select;

const dataSchoolCategory = [
  { key: "1", value: "Samagra" },
  { key: "2", value: "STAR" },
  { key: "3", value: "PM SHRI" },
];

const columns = (openPdf) => [
  {
    title: "S.NO.",
    dataIndex: "key",
    key: "key",
  },
  {
    title: "STATE",
    dataIndex: "state",
    key: "state",
  },
  {
    title: "SCHOOL COUNT",
    dataIndex: "schoolCount",
    width: 5,
    key: "schoolCount",
  },
  {
    title: "Trade",
    dataIndex: "trade_name",
    key: "trade_name",
  },
  {
    title: "Job Roles",
    dataIndex: "job_roles",
    key: "job_roles",
  },
  {
    title: "School Category",
    dataIndex: "School_category",
    key: "School_category",
  },
  {
    title: "DATE FROM",
    dataIndex: "dateFrom",
    key: "dateFrom",
  },
  {
    title: "DATE TO",
    dataIndex: "dateTo",
    key: "dateTo",
  },
  {
    title: "NO. DAYS LEFT",
    dataIndex: "daysLeft",
    key: "daysLeft",
  },
  {
    title: "VIEW/DOWNLOAD",
    dataIndex: "pdfUrl",
    key: "viewDownload",
    render: (pdfUrl) => (
      <Button onClick={() => openPdf(pdfUrl)} icon={<DownloadOutlined />}>
        Download
      </Button>
    ),
  },
];

const MouStatus = () => {
  // const today = new Date();

  // const [formData, setFormData] = useState({
  //   state: "",
  //   school_count: "",
  //   trade_name: "",
  //   job_roles: "",
  //   School_category: "",
  //   from_date: "",
  //   to_date: "",
  // });
  const [pdfFile, setPdfFile] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false); // Loading state

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getJobtrades());
    dispatch(getSectors());
    dispatch(getStates());
    dispatch(getMous());
  }, [dispatch]);

  const [form] = Form.useForm();
  const [selectedState, setSelectedState] = useState("");
  const statelistState = useSelector((state) => state.statecity.statelist);
  const jobtradelistState = useSelector((state) => state.brand.jobtrades);
  const tradesectorlistState = useSelector((state) => state.brand.sectors);
  const moulistState = useSelector((state) => state.mou.mous);

  useEffect(() => {
    const data1 = moulistState.map((MOU, index) => {
      const today = new Date().setHours(0, 0, 0, 0);
      const MOUDate = new Date(MOU.to_date).setHours(0, 0, 0, 0);
      const Moudifference = getDateDifference(today, MOU.to_date);
      return {
        key: index + 1,
        state: MOU.state,
        schoolCount: MOU.school_count,
        trade_name: MOU.trade_name,
        job_roles: MOU.job_roles,
        School_category: MOU.School_category,
        dateFrom: formatDate(MOU.from_date),
        dateTo: formatDate(MOU.to_date),
        daysLeft: (
          <Tag color={Moudifference.days < 90 ? "red" : "green"}>
            {today >= MOUDate ? "MOU Expired" : `${Moudifference.days} Day`}
          </Tag>
        ),
        pdfUrl: MOU.pdfUrl,
      };
    });

    setFilteredData(data1);
  }, [moulistState]);

  const handleStateChange = (value) => {
    setSelectedState(value);
  };

  const handleFileChange = (e) => {
    setPdfFile(e.target.files[0]);
  };

  const openPdf = (pdfUrl) => {
    window.open(pdfUrl, "_blank");
  };

  const handleSubmit = async (values) => {
    setLoading(true); // Set loading to true when submission starts
    try {
      const userinfo = localStorage.getItem("user");
      const userData = JSON.parse(userinfo);
      const token = userData.token;

      if (!token) {
        throw new Error("Token not found in local storage");
      }

      // Create form data to handle file upload
      const formData = new FormData();
      formData.append("state", values.state);
      formData.append("school_count", values.school_count);
      formData.append("trade_name", values.trade_name);
      formData.append("job_roles", values.job_roles);
      formData.append("School_category", values.School_category);
      formData.append(
        "from_date",
        values.from_date.tz("Asia/Kolkata").format()
      );
      formData.append("to_date", values.to_date.tz("Asia/Kolkata").format());

      if (pdfFile) {
        formData.append("pdfFile", pdfFile);
      }

      const storeResponse = await axios.post(`${base_url}mou`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      if (storeResponse.status === 200) {
        toast.dismiss();
        toast.success("MOU Uploaded Successfully!", { autoClose: 5000 });
        dispatch(getMous());
        form.resetFields();
        navigate("/admin/add-bulkschool");
      } else {
        toast.dismiss();
        toast.error("Failed to upload MOU!", { autoClose: 5000 });
      }
    } catch (error) {
      toast.dismiss();
      toast.error("An error occurred. Please try again.", { autoClose: 5000 });
    } finally {
      setLoading(false); // Set loading to false when submission ends
    }
  };

  const handleButtonClickSchool = () => {
    navigate("/admin/add-bulkschool");
  };

  const handleSearch = (values) => {
    console.log("Print Search data ----", values);
    console.log("Print Selected State data ----", selectedState);

    let filtered = moulistState;
    if (values.state) {
      filtered = filtered.filter((mou) => mou.state === selectedState);
    }

    const data = filtered.map((MOU, index) => {
      const today = new Date().setHours(0, 0, 0, 0);
      const MOUDate = new Date(MOU.to_date).setHours(0, 0, 0, 0);
      const Moudifference = getDateDifference(today, MOU.to_date);

      return {
        key: index + 1,
        state: MOU.state,
        schoolCount: MOU.school_count,
        trade_name: MOU.trade_name,
        job_roles: MOU.job_roles,
        School_category: MOU.School_category,
        dateFrom: formatDate(MOU.from_date),
        dateTo: formatDate(MOU.to_date),
        daysLeft: (
          <Tag color={Moudifference.days < 90 ? "red" : "green"}>
            {today >= MOUDate ? "MOU Expired" : `${Moudifference.days} Days`}
          </Tag>
        ),
        pdfUrl: MOU.pdfUrl,
      };
    });

    setFilteredData(data);
  };

  const csvHeaders = [
    { label: "State", key: "state" },
    { label: "School Count", key: "schoolCount" },
    { label: "Trade", key: "trade_name" },
    { label: "Job Role", key: "job_roles" },
    { label: "School Category", key: "School_category" },
    { label: "Date From", key: "dateFrom" },
    { label: "Date To", key: "dateTo" },
    { label: "Days Left ", key: "daysLeft" },
  ];

  return (
    <div style={{ padding: 20 }}>
      <h3 className="mb-4 title">MOU Upload</h3>

      <Button
        type="primary"
        className="exportcsv"
        onClick={handleButtonClickSchool}
      >
        <UploadOutlined />
        Bulk Upload Schools
      </Button>

      <Divider />
      <div
        className="site-layout-background"
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 20,
          padding: "20px",
          backgroundColor: "#ffffff",
          border: "1px solid #eef2f6",
          borderRadius: "12px",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)",
        }}
      >
        <Form
          form={form}
          layout="inline"
          onFinish={handleSubmit}
          name="uploadMOU"
          scrollToFirstError
        >
          <Form.Item
            label="Select State"
            name="state"
            rules={[{ required: true, message: "Please Select State!" }]}
          >
            <Select style={{ width: 150 }} placeholder="Select State">
              {statelistState.map((i) => (
                <Select.Option key={i.code} value={i.state_name}>
                  {i.state_name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Enter School Count"
            name="school_count"
            rules={[{ required: true, message: "Please Enter School Count!" }]}
          >
            <Input style={{ width: 100, marginBottom: 10 }} />
          </Form.Item>

          <Form.Item
            label="Select Trades"
            name="trade_name"
            rules={[{ required: true, message: "Please Select Trades!" }]}
          >
            <Select
              mode="multiple"
              placeholder="Select Trades"
              style={{ width: 150, marginBottom: 10 }}
            >
              {tradesectorlistState.map((trade) => (
                <Select.Option key={trade.title} value={trade.title}>
                  {trade.title}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Select Job Role"
            name="job_roles"
            rules={[{ required: true, message: "Please Select Job Role!" }]}
          >
            <Select
              mode="multiple"
              placeholder="Select Job Role"
              style={{ width: 250, marginBottom: 10 }}
            >
              {jobtradelistState.map((trd) => (
                <Select.Option key={trd.title} value={trd.title}>
                  {trd.title}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="School_category"
            label="School Category"
            rules={[
              { required: true, message: "Please Select School Category!" },
            ]}
          >
            <Select
              mode="multiple"
              placeholder="Select School Category"
              style={{ width: 200, marginBottom: 10 }}
            >
              {dataSchoolCategory.map((sec) => (
                <Option key={sec.value} value={sec.value}>
                  {sec.value}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="From"
            name="from_date"
            rules={[{ required: true, message: "Please Select From Date!" }]}
          >
            <DatePicker />
          </Form.Item>
          <Form.Item
            label="To"
            name="to_date"
            rules={[{ required: true, message: "Please Select To Date!" }]}
          >
            <DatePicker />
          </Form.Item>

          <Form.Item name="mou_upload">
            <Tooltip title="Upload PDF file Only">
              <input type="file" name="file" onChange={handleFileChange} />
            </Tooltip>
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              style={{ width: 100, marginTop: 16, marginRight: 26 }}
              htmlType="submit"
              loading={loading} // Set loading prop
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>
      <Divider />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 20,
        }}
      >
        <h3 className="mb-4 title">MOU Status</h3>

        <Form layout="inline" onFinish={handleSearch}>
          <Form.Item
            label="Select State"
            name="state"
            rules={[{ required: true, message: "Please Select State!" }]}
          >
            <Select
              placeholder="Select State"
              onChange={handleStateChange}
              style={{ width: 120 }}
            >
              {statelistState.map((i) => (
                <Select.Option key={i.code} value={i.state_name}>
                  {i.state_name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              View
            </Button>
          </Form.Item>
        </Form>

        <CSVLink
          data={filteredData}
          headers={csvHeaders}
          filename={`industrial-visit_${new Date().toISOString()}.csv`}
        >
          <Button type="primary" className="exportcsv">
            <ExportOutlined /> Export to CSV
          </Button>
        </CSVLink>
      </div>

      <Table
        className="custom-table"
        columns={columns(openPdf)}
        dataSource={filteredData}
      />
    </div>
  );
};

export default MouStatus;
